/** @file bone.split's share of the new bone per vertex: a smoothstep across the cut along the bone axis. */

/** Per point [x, y, …] (x along the split bone), the new bone's share: 0 up to cut − band, 1 from cut + band, smoothstep between. */
export function splitRamp(points: readonly number[], cut: number, band: number): number[] {
  const out: number[] = [];
  for (let i = 0; i + 1 < points.length; i += 2) {
    const t = Math.min(1, Math.max(0, ((points[i] ?? 0) - (cut - band)) / (2 * band)));
    out.push(t * t * (3 - 2 * t));
  }
  return out;
}
